export const SET_TEAM_TEAMS = "setTeams";
export const SET_FETCHING = "setFetching";
